import { render } from "./lamps.vue?vue&type=template&id=a3390fb2&scoped=true"
import script from "./lamps.vue?vue&type=script&lang=js"
export * from "./lamps.vue?vue&type=script&lang=js"

import "./lamps.vue?vue&type=style&index=0&id=a3390fb2&scoped=true&lang=scss"

import exportComponent from "/home/alligator/www/HOME/smarthomeui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3390fb2"]])

export default __exports__